import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import AdminTextInput from '../../../components/admin/admin-text-input';
import AdminSelect from '../../../components/admin/admin-default-select';
import AdminPhone from '../../../components/admin/admin-phone';
import * as distrctSiteUserApi from '../../../api/districtsiteuserapi'; 
import { getAllSiteUsersList} from '../../../store/district-account-reducer';

import Loader from '../../../components/Loader.js';
import { getById } from '../../../api/districtapi'; 

export function UserReviewerRoleModal({ show, onClose, districtId, isEditMode = false, handleAddSiteUser, existingSiteUser = null }) {
    if (!show) return null;
    const [loadingData, setLoadingData] = useState(true);
    const districtSiteUser = useSelector(getAllSiteUsersList);
    const [user, setUser] = useState({
        siteUserId: null,
        role: 'Reviewer', 
        companyName: '',
        phone: '',
        email: '',
        fullName: '',
        notify: false,
        schoolUsersList: [],
        bAdminPermission: false,
        bApproverPermission: false,
    });  

    const [districtName, setDistrictName] = useState(''); 
    const [districtUsers, setDistrictUsers] = useState([]);
    const [createDistrictAdmin, setCreateDistrictAdmin] = useState(false);
    const [validation, setValidation] = useState({
        siteUserId: true,
        fullName: true,
        email: true,
        phone: true,
        companyName: true,
        permissions: true
    });
    console.log("districtName", districtName);
    useEffect(() => {
        if (districtId) {
            getById(districtId)
                .then((response) => {
                    if (response.data.success) {
                        setDistrictName(response.data.data.name);
                    }
                })
                .catch(ex => {
                    console.log(ex);
                });
        }
    }, [districtId]);

    useEffect(() => {

        const loadInitialData = async () => {
            setLoadingData(true);
            try { 
                 
                const schoolUsersResponse = await distrctSiteUserApi.getAllSchoolUsersByDistrictId(districtId);
           
                let schoolUsers = [];
                if (schoolUsersResponse.data.success) {
                    schoolUsers = schoolUsersResponse.data.data.map(a => ({
                        id: a?.siteUsers?.id,
                        email: a?.siteUsers?.email,
                        fullName: a?.siteUsers?.fullName,
                        phone: a?.siteUsers?.phone,
                        organization: a?.siteUsers?.organization,
                        role: a.siteUsers?.title || 'Reviewer',
                        schoolUsersList: a?.schoolUsersList || [],
                        password: a?.siteUsers?.password || '',
                        notify: a.notify,
                        bAdminPermission: a?.bAdminPermission,
                        bApproverPermission: a?.bApproverPermission,
                        isDistrictGlobalAdmin: a?.isDistrictGlobalAdmin,
                        isReviewer: a?.isReviewer
                    }));
                }

                // 2. Fetch reviewers
                const reviewersResponse = await distrctSiteUserApi.getAllReviewers(districtId);
                let reviewers = [];
                if (reviewersResponse.data.success) {
                    reviewers = reviewersResponse.data.data.map(a => ({
                        id: a.id,
                        email: a.email,
                        fullName: a.fullName,
                        phone: a.phone,
                        organization: a.organization,
                        role: a.title || 'Reviewer',
                        schoolUsersList: []
                    }));
                } 
                // 3. Redux district site users
                const reduxUsers = districtSiteUser.map(user => ({
                    id: user?.siteUsers?.id,
                    email: user?.siteUsers?.email,
                    fullName: user?.siteUsers?.fullName,
                    phone: user?.siteUsers?.phone,
                    organization: user?.siteUsers?.organization,
                    role: user?.siteUsers?.title || 'Reviewer',
                    schoolUsersList: user?.schoolUsersList || [],  
                    notify: user?.notify,
                    bAdminPermission: user?.bAdminPermission,
                    bApproverPermission: user?.bApproverPermission,
                    isDistrictGlobalAdmin: user?.isDistrictGlobalAdmin,
                    isReviewer: user?.isReviewer

                     
                })); 
                // Combine all three lists
                const combinedUsers = [...schoolUsers, ...reviewers, ...reduxUsers]; 
                const uniqueUsersMap = new Map();
                combinedUsers.forEach(u => {
                    if (!uniqueUsersMap.has(u.id)) {
                        uniqueUsersMap.set(u.id, u);
                    } else { 
                        const existing = uniqueUsersMap.get(u.id);
                        if (u.schoolUsersList && u.schoolUsersList.length > 0) {
                            existing.schoolUsersList = u.schoolUsersList;
                        }
                    }
                });
                const filteredUsers = Array.from(uniqueUsersMap.values()).filter(u => !u.isReviewer);
                setDistrictUsers(filteredUsers);
                 
            } catch (err) {
                console.error('Error loading modal data:', err);
            } finally {
                setLoadingData(false);
            }
        };

        loadInitialData();
    }, [districtId, existingSiteUser]);



    useEffect(() => {
        if (existingSiteUser) {  
            setUser({ 
                siteUserId: existingSiteUser.siteUserId,
                role: existingSiteUser.role,
                fullName: existingSiteUser.siteUsers.fullName,
                email: existingSiteUser.siteUsers.email,
                phone: existingSiteUser.siteUsers.phone,
                companyName: existingSiteUser.siteUsers.organization,
                notify: existingSiteUser.notify,
                schoolUsersList: existingSiteUser.schoolUsersList || [],
                bAdminPermission: existingSiteUser.bAdminPermission,
                bApproverPermission: existingSiteUser.bApproverPermission,
                isDistrictGlobalAdmin: existingSiteUser.isDistrictGlobalAdmin,
                isReviewer: true
            });
            setCreateDistrictAdmin(true);
        }
    }, [existingSiteUser]);

    const handleSelectingDistrictUser = (value) => {
        const selectedDistrictUser = districtUsers.find(u => u.id === value);
        if (value === "") {
            setUser(prev => ({ ...prev, siteUserId: null, bApproverPermission: false, schoolUsersList: [] }));
        } else if (value === "new") {
            setCreateDistrictAdmin(true);
            setUser(prev => ({ ...prev, siteUserId: null, bApproverPermission: false, schoolUsersList: [] }));
        } else {
            setCreateDistrictAdmin(false);
            setValidation({ ...validation, siteUserId: value != '' });
            setUser(prev => ({
                ...prev,
                siteUserId: value,
                schoolUsersList: selectedDistrictUser?.schoolUsersList || []
            }));
        }
    }; 


    const handleSave = () => { 
        let isValid = true;
        const validate = {
            siteUserId: true,
            fullName: true,
            email: true,
            phone: true,
            companyName: true,
            password: true,
            permissions: true
        };   

        if (createDistrictAdmin) {
            if (!user.fullName) { validate.fullName = false; isValid = false; }
            if (!user.email) { validate.email = false; isValid = false; }
            if (!user.phone) { validate.phone = false; isValid = false; }
        } else {
            if (!user.siteUserId) {
                validate.siteUserId = false;
                isValid = false;
            }
        } 

        setValidation(validate);
        if (!isValid) return;

        if (!createDistrictAdmin) {
            const selectedUser = districtUsers.find(u => u.id === user.siteUserId);
            const updatedUser = {  
                DistrictId: districtId,
                SiteUserId: user.siteUserId,
                Role: selectedUser?.role ||  "Reviewer",
                Email: selectedUser?.email || '',
                FullName: selectedUser?.fullName || '',
                Phone: selectedUser?.phone || '',
                CompanyName: selectedUser?.organization || districtName || '',
                Password: user.password || '',
                Notify: selectedUser?.notify,
                SchoolUsersList: selectedUser?.schoolUsersList || [],
                BAdminPermission: selectedUser?.bAdminPermission,
                BApproverPermission: selectedUser?.bApproverPermission,
                IsDistrictGlobalAdmin: selectedUser?.isDistrictGlobalAdmin,
                IsReviewer: true
            };
            handleAddSiteUser(updatedUser);

        } else {  
            handleAddSiteUser({ 
                DistrictId: districtId,
                SiteUserId: user.siteUserId,
                Role: "Reviewer",
                Email: user.email,
                FullName: user.fullName,
                Phone: user.phone,
                CompanyName: districtName,
                Password: user.password,
                Notify: user?.notify,
                SchoolUsersList: user?.schoolUsersList || [],
                BAdminPermission: user?.bAdminPermission,
                BApproverPermission: user?.bApproverPermission,
                IsDistrictGlobalAdmin: user?.isDistrictGlobalAdmin,
                IsReviewer: true
            });
        }
        onClose();
    }; 
    return (
        <div className="admin-modal-overlay">
            <div className="admin-modal admin-add-role">
                {loadingData ? <Loader /> : <>
                    <div className="admin-modal-scroll">
                        <button className="admin-modal-close" onClick={onClose}>
                            <span className="material-symbols-rounded">close</span>
                        </button>
                        <h2 className="admin-modal-heading">{isEditMode ? 'Edit District Role' : 'Add District Role'}</h2>
                     
                        {!isEditMode && (
                            <div className="admin-modal-row">
                                <div className="admin-modal-cell">
                                    <AdminSelect
                                        id="district-user-select"
                                        label="Select Account"
                                        value={createDistrictAdmin ? 'new' : user.siteUserId || ''}
                                        onChange={handleSelectingDistrictUser}
                                        options={[
                                            { value: '', label: '[Select a District User]' },
                                            ...districtUsers.map(a => ({
                                                value: a.id,
                                                label: `${a.fullName} (${a.email})`
                                            }))

                                        ]}
                                    />
                                </div>
                            </div>
                        )} 

                        {(createDistrictAdmin || isEditMode) && (
                            <>
                                <div className="admin-modal-row">
                                    <div className="admin-modal-cell">
                                        <AdminTextInput
                                            id="full-name"
                                            label="First & Last Name"
                                            placeholder=""
                                            isRequired={true}
                                            value={user.fullName ?? ''}
                                            validated={validation.fullName}
                                            onChange={(value) => {
                                                setUser({ ...user, fullName: value });
                                                setValidation({ ...validation, fullName: value != '' });
                                            }}
                                            requiredText="First & Last Name is required"
                                        />
                                    </div>
                                </div>
                                <div className="admin-modal-row">
                                    <div className="admin-modal-cell">
                                        <AdminTextInput
                                            id="email-address"
                                            label="Email Address"
                                            placeholder=""
                                            isRequired={true}
                                            value={user.email ?? ''}
                                            validated={validation.email}
                                            onChange={(value) => {
                                                setUser({ ...user, email: value });
                                                setValidation({ ...validation, email: value != '' });
                                            }}
                                            requiredText="Email Address is required"
                                        />
                                    </div>
                                </div>
                                <div className="admin-modal-row">
                                    <div className="admin-modal-cell">
                                        <AdminPhone
                                            id="phone-number"
                                            label="Phone Number"
                                            type="phone"
                                            placeholder=""
                                            isRequired={true}
                                            value={user.phone ?? ''}
                                            loaded={(isEditMode == true && user.siteUserId != null) || isEditMode == false}
                                            validated={validation.phone}
                                            onChange={(value) => {
                                                setUser({ ...user, phone: value });
                                            }}
                                            onValidation={(valid) => { setValidation({ ...validation, phone: valid }); }}
                                            requiredText="A valid phone number is required"
                                        />
                                    </div>
                                </div>
                                <div className="admin-modal-row">
                                    <div className="admin-modal-cell">
                                        <AdminTextInput
                                            id="password"
                                            label="Password"
                                            inputType="password"
                                            placeholder="Leave blank to let user create their own password"
                                            isRequired={false}
                                            value={user.password ?? ''}
                                            onChange={(value) => {
                                                setUser({ ...user, password: value });
                                            }}
                                        />
                                    </div>
                                </div>
                            </>
                        )} 
                       

                        <div className="admin-modal-button-wrap">
                            <button className="admin-modal-button" onClick={onClose}>Cancel</button>

                            <button className="admin-modal-button power" onClick={handleSave}>Save Changes</button>
                        </div>
                    </div>
                </>
                }
            </div>
        </div>
    );
}

UserReviewerRoleModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    districtId: PropTypes.number.isRequired,
    isEditMode: PropTypes.bool,
    handleAddSiteUser: PropTypes.func.isRequired,
    existingSiteUser: PropTypes.object,
};
